import { render, staticRenderFns } from "./GuideforWallet.vue?vue&type=template&id=6ea8cd98&scoped=true"
import script from "./GuideforWallet.vue?vue&type=script&lang=js"
export * from "./GuideforWallet.vue?vue&type=script&lang=js"
import style0 from "./GuideforWallet.vue?vue&type=style&index=0&id=6ea8cd98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea8cd98",
  null
  
)

export default component.exports